export const ownerDocument = (el)=>{
    var _el_ownerDocument;
    return (_el_ownerDocument = el === null || el === void 0 ? void 0 : el.ownerDocument) !== null && _el_ownerDocument !== void 0 ? _el_ownerDocument : document;
};
export const ownerWindow = (el)=>{
    var _el_ownerDocument;
    var _el_ownerDocument_defaultView;
    return (_el_ownerDocument_defaultView = el === null || el === void 0 ? void 0 : (_el_ownerDocument = el.ownerDocument) === null || _el_ownerDocument === void 0 ? void 0 : _el_ownerDocument.defaultView) !== null && _el_ownerDocument_defaultView !== void 0 ? _el_ownerDocument_defaultView : window;
};

//# sourceMappingURL=domHelpers.js.map